import { PivotQuery } from './PivotQuery';
export var PivotLevel;
(function (PivotLevel) {
    function make(series, query) {
        return {
            name: PivotQuery.Series.name(series),
            query: query.name,
        };
    }
    PivotLevel.make = make;
})(PivotLevel || (PivotLevel = {}));
